export const FEATURE_FLAG = {
  commandCentre: 'command_centre',
  commandCentreCompoundMap: 'command_centre_compound_map',
  questionnaire: 'questionnaire',
  loadPulls: 'load_pull',
} as const;

export type FeatureFlagName = (typeof FEATURE_FLAG)[keyof typeof FEATURE_FLAG];

export const DEFAULT_FLAGS: Record<
  FeatureFlagName,
  { enabled: boolean; value: null }
> = {
  [FEATURE_FLAG.commandCentre]: { enabled: false, value: null },
  [FEATURE_FLAG.commandCentreCompoundMap]: { enabled: false, value: null },
  [FEATURE_FLAG.questionnaire]: { enabled: false, value: null },
  [FEATURE_FLAG.loadPulls]: { enabled: false, value: null },
};
